import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { switchLanguagePath, useLang } from '../i18n';

const SITE = 'https://www.shopflexstudios.com';

export default function Seo({ title, description, image = '/android-chrome-512x512.png' }) {
  const { lang, dir, t } = useLang();
  const { pathname } = useLocation();
  const fullTitle = title ? `${t(title)} | ShopFlex Studios` : 'ShopFlex Studios';
  const desc = t(description);
  const en = lang === 'en' ? pathname : switchLanguagePath(pathname, 'ar');
  const ar = lang === 'ar' ? pathname : switchLanguagePath(pathname, 'en');

  return (
    <Helmet htmlAttributes={{ lang, dir }}>
      <title>{fullTitle}</title>
      {desc && <meta name="description" content={desc} />}
      <link rel="canonical" href={SITE + pathname} />
      <link rel="alternate" hrefLang="en" href={SITE + en} />
      <link rel="alternate" hrefLang="ar" href={SITE + ar} />
      <link rel="alternate" hrefLang="x-default" href={SITE + en} />
      <meta property="og:title" content={fullTitle} />
      {desc && <meta property="og:description" content={desc} />}
      <meta property="og:image" content={SITE + image} />
      <meta property="og:url" content={SITE + pathname} />
      <meta property="og:locale" content={lang === 'ar' ? 'ar_EG' : 'en_US'} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}
